export const CHART_WIDGET_LINES_SET = 'CHART_WIDGET_LINES_SET'

export const setChartWidgetLines = (tradeId) => {
	return {
		payload: tradeId,
		type: CHART_WIDGET_LINES_SET
	}
}

